import { Box, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import React from 'react';

// react-hot-toast recreates `t` on every internal store tick (pause timers,
// height measurement, exit animation) even when nothing user-visible changed.
// Compare only what actually affects this component so it doesn't re-render
// (and re-run its body) dozens of times per toast.
const areEqual = (prev, next) => prev.payload === next.payload && prev.t.visible === next.t.visible;

export const CustomToast = React.memo(({ payload, t }) => {
  const title = payload?.notification?.title ?? payload?.data?.title ?? 'Notification';
  const body = payload?.notification?.body ?? payload?.data?.body ?? '';    
  return (
    <Box
      sx={{
        maxWidth: '22rem',
        width: '100%',
        backgroundColor: '#fff',
        boxShadow:
          'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
        borderRadius: '0.5rem',
        pointerEvents: 'auto',
        display: 'flex',
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        animation: t.visible ? 'enter 0.2s ease-out' : 'leave 0.15s ease-in forwards',
        '@keyframes enter': {
          '0%': { transform: 'translateY(4px)', opacity: 0 },
          '100%': { transform: 'translateY(0)', opacity: 1 },
        },
        '@keyframes leave': {
          '0%': { transform: 'translateY(0)', opacity: 1 },
          '100%': { transform: 'translateY(4px)', opacity: 0 },
        },
      }}
    >
      <Box sx={{ flex: 1, width: 0, p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Box sx={{ flexShrink: 0, pt: 0.5 }}>
            <Iconify icon="iconoir:bell-notification-solid" width={30} height={30} sx={{ color: '#880152' }} />
          </Box>
          <Box sx={{ ml: 2, flex: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
              {title}
            </Typography>
            {body && (
              <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                {body}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}, areEqual);